import Meta from '@/components/common/Meta'

import CollegeStorageSolutionPage from '@/v2/components/pages/landing-pages/college-storage-solution-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/college-storage-solution-page'

interface CollegeStorageSolutionPageProps {}

const Page: React.FC<CollegeStorageSolutionPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.college_storage_solution.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.college_storage_solution?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.college_storage_solution?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <CollegeStorageSolutionPage />
    </>
  )
}

export default Page
